import { isPhoneLayoutFromCSS } from "./GetPhoneLayout";

// Touch devices default to a reduced zoom to fit more of the chart. Phone-size screens (per
// styles/global/_phone-layout.scss) get a bit more zoom instead — readability matters more
export const TABLET_DEFAULT_ZOOM = 0.5;
export const PHONE_DEFAULT_ZOOM = 0.75;

export const GetTouchDefaultZoom = (): number =>
  isPhoneLayoutFromCSS() ? PHONE_DEFAULT_ZOOM : TABLET_DEFAULT_ZOOM;
